module.exports = __webpack_public_path__ + "img/Group 1890.a5d146cc.png";